define('modules/lists/modals/views/list.quota2.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'modules/lists/modals/views/list.quota.view',
    "text!modules/lists/modals/templates/list.quota2.template.html"
], function(
    Prospector,
    $, _,Backbone,
    ListQuotaView,
    Template
){
    var ListQuotaView2 = ListQuotaView.extend({
        template: _.template(Template),

        onRender:function(){
            this.$('a').attr("href", "#" +  this.linkToSubscriptionPage());
            this.$('a').attr("target", "_blank" );
        },

        linkToSubscriptionPage:function() {
            this.clickUrl = 'subscriptionLimits';
            return this.clickUrl;
        }

    });
    return ListQuotaView2;
});
